/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import PropTypes from 'prop-types';
import styles from './styles/controls.css';

export const RewindButton = ({amountToRewindStream, rewindStream}) => (
  <i
    className={`${styles.rewindButton}`}
    title="Rewind"
    onClick={() => rewindStream(10)}
  >
    <span className={styles.rewindButtonLabel}>{amountToRewindStream}</span>
  </i>
);

RewindButton.propTypes = {
  amountToRewindStream: PropTypes.number.isRequired,

  rewindStream: PropTypes.func.isRequired
};

export default RewindButton;